import { cn } from '@/lib/utils'
import type { Subscription } from '@/api/types'

const badgeBaseClass = 'inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium'
const enabledClass = 'bg-emerald-50 text-emerald-700 border-emerald-200'
const disabledClass = 'bg-muted text-muted-foreground border-border'

export function ShipmentAutomationBadge({ subscription }: { subscription: Subscription | null }): React.ReactElement {
  const isEnabled = subscription !== null && subscription.enable_postnord

  if (!isEnabled) {
    return <span className={cn(badgeBaseClass, disabledClass)}>Av</span>
  }

  return <span className={cn(badgeBaseClass, enabledClass)}>På</span>
}
